import React, { useEffect, useState } from 'react';
import map from 'lodash/map';
import Cookies from 'universal-cookie';
import { Route, Routes, Navigate } from 'react-router-dom';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';
import dashboardLayout from 'Layouts/Dashboard';
import publicLayout from 'Layouts/Public';
import Dashboard from 'pages/Dashboard';
import CourseList from 'pages/CourseList';
import SharedBadge from 'pages/SharedBadge';
import EvaluationDigitalForm from 'pages/EvaluationDigitalForm/FormView';
import Requests from 'pages/Requests';
import Search from 'pages/Search';
import SearchMembers from 'pages/Search/Components/SearchMembers';
import SearchResources from 'pages/Search/Components/SearchResources';
import MyClubs from 'pages/MyClubs';
import ClubDetails from 'pages/MyClubs/Components/ClubDetails';
import Notifications from 'pages/Notifications';
import FeedbackNotification from 'pages/Notifications/NotificationDetailPages/Feedback';
import ResourcesNotification from 'pages/Notifications/NotificationDetailPages/Resources';
import RequestNotification from 'pages/Notifications/NotificationDetailPages/Request';
import UserProfile from 'pages/Profile';
import SpeechCertificates from 'pages/SpeechCertificates';
import SpeechDashboard from 'pages/SpeechDashboard';
import SpeechValidation from 'pages/SpeechValidation';
import MyCohort from 'pages/MyCohort';
import AssessmentForm from 'pages/AssessmentForm';
import errorLayout from 'Layouts/404';
import Error from 'pages/Error';
import PrivateRoute from 'components/PrivateRoute';
import { Role, REQUEST_TYPES } from 'constant';

import SpeedIcon from '@mui/icons-material/Speed';
import axiosClient from 'utils/client';
import { useAppContext } from 'contexts/AppContext';
import Loader from 'elements/Loader';
import BcmDashboard from 'pages/BcmDashboard';
import { useIsSpeechCraftMFE } from 'hooks';
import EvaluationFormSelectionSection from 'pages/EvaluationDigitalForm';

const TOASTMASTER_AUTH_URL = () => `${getConfig().LMS_BASE_URL}${getConfig().CSRF_TOKEN_API_PATH}`;

export const initializeSession = async () => {
  const cookies = new Cookies();
  const resp = await axiosClient({
    url: TOASTMASTER_AUTH_URL(),
    method: 'GET',
  });
  cookies.remove('csrftoken');
  cookies.set('csrftoken', resp?.data.csrfToken, { path: '/' });
  return resp?.data.csrfToken;
};

export const RoutesHOC = (routes: any, defaultPath: any) => {
  const HOC = (props: any) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const cookies = new Cookies();
    const csrftoken = cookies.get('csrftoken');
    const isSpeechCraftMFE = useIsSpeechCraftMFE();

    useEffect(() => {
      const fetchSession = async () => {
        if (!csrftoken) {
          const data = await initializeSession();
          setIsLoaded(true);
        } else {
          setIsLoaded(true);
        }
      };
      fetchSession();
    }, [csrftoken]);

    const { isReleasingHijackUser } = useAppContext();

    if (!isLoaded || isReleasingHijackUser) {
      return <Loader position='absolute' background='transparent' />;
    }

    return (
      <>
        <Routes>
          {map(routes, (route: any) => {
            const isRequestPath =
              route.path === DashboardRoutes.REQUESTS.path && isSpeechCraftMFE;
            const componentProps = {
              ...(isRequestPath && { requestType: REQUEST_TYPES.EVALUATION }),
            };

            return (
              <Route
                key={route.name}
                path={route.path}
                element={
                  <PrivateRoute roles={route.roles} ispublic={route.ispublic}>
                    <route.component {...componentProps} />
                  </PrivateRoute>
                }
              />
            );
          })}
          <Route path="*" element={<Navigate to={defaultPath} replace />} />
        </Routes>
      </>
    );
  };

  return HOC;
};

export const DashboardRoutes = {
  COURSE_LIST: {
    name: 'CourseList',
    path: `courseList/:category`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: CourseList,
  },
  NOTIFICATIONS: {
    name: 'Notifications',
    path: `/notifications/:slug?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: Notifications,
    routeProps: { exact: true },
  },
  FEEDBACK_NOTIFICATION: {
    name: 'Notifications',
    path: `notifications/feedback/:slug`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: FeedbackNotification,
  },
  SPEECH_VALIDATION: {
    name: 'SpeechValidation',
    path: `speech-validation/:speechId?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: SpeechValidation,
    roles: [Role.coordinator],
  },
  SPEECH_CERTIFICATES: {
    name: 'SpeechCertificates',
    path: `certificates`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: SpeechCertificates,
    roles: [Role.coordinator],
  },
  // REQUEST_NOTIFICATION: {
  //   name: 'Notifications',
  //   path: `notifications/request/:slug`,
  //   icon: <SpeedIcon />,
  //   isDisabled: true,
  //   component: RequestNotification,
  // },
  RESOURCES_NOTIFICATION: {
    name: 'Notifications',
    path: `notifications/resources/:slug`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: ResourcesNotification,
  },
  RESOURCES_DETAIL: {
    name: 'ResourcesDetail',
    path: `/resources/resources-details/:assetUuid`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: ResourcesNotification,
  },
  EVALUATION_FORM_SELECTION: {
    name: 'DigitalEvaluationFormSelection',
    path: `/feedback/evaluation-form/:id/:title`,
    icon: <SpeedIcon />,
    isDisabled: true,
    exact: true,
    component: EvaluationFormSelectionSection,
  },
  DIGITAT_EVALUATION_FORM: {
    name: 'DigitalEvaluationForm',
    path: `/feedback/evaluation-form/:id`,
    icon: <SpeedIcon />,
    isDisabled: true,
    exact: true,
    component: EvaluationDigitalForm,
  },
  REQUESTS: {
    name: 'request',
    path: `requests/:notificationId?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: Requests,
  },
  SEARCH_MEMBERS: {
    name: 'search',
    path: `/search/members`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: SearchMembers,
  },
  SEARCH_RESOURCES_DETAILS: {
    name: 'search',
    path: `/search/resources/details/:assetUuid`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: ResourcesNotification,
  },
  SEARCH_RESOURCES: {
    name: 'search',
    path: `/search/resources`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: SearchResources,
  },
  SEARCH: {
    name: 'search',
    path: `/search`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: Search,
  },
  PROFILE: {
    name: 'club',
    path: `/my-clubs/profile/:clubId/:username/:activeSection?`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: UserProfile,
  },
  COORDINATOR_PROFILE_ASSESSMENT_FORM: {
    name: 'Assessment',
    path: `/my-cohort/profile/:username/assessment-form/:formId/:formTitle/:progress`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: AssessmentForm,
    roles: [Role.coordinator],
  },
  SPEECHCRAFTER_PROFILE: {
    name: 'speechcrafter profile',
    path: `/my-cohort/profile/:username/:activeSection?/:activeSubSection?`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: UserProfile,
    roles: [Role.coordinator, Role.speechcrafter],
  },
  CLUB_DETAILS: {
    name: 'club',
    path: `/my-clubs/:clubId`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: ClubDetails,
    exact: true,
  },
  MY_COHORT: {
    name: 'my cohort',
    path: `/my-cohort`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: MyCohort,
    roles: [Role.coordinator, Role.speechcrafter],
  },
  CLUBS: {
    name: 'club',
    path: `/my-clubs`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: MyClubs,
  },
  PROFILE_ASSESSMENT_FORM: {
    name: 'Assessment',
    path: `/profile/assessment-form/:formId/:formTitle/:progress`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: AssessmentForm,
    roles: [Role.speechcrafter],
  },
  MY_PROFILE: {
    name: 'club',
    path: `profile/:activeSection?/:activeSubSection?`,
    icon: <SpeedIcon />,
    isDisabled: false,
    component: UserProfile,
  },
  SPEECH_DASHBOARD: {
    name: 'Speech Dashboard',
    path: `speech-dashboard/:activeOption?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: SpeechDashboard,
    roles: [Role.coordinator],
  },
  BCM_DASHBOARD: {
    name: 'Bcm Dashboard',
    path: `/bcm-dashboard/:activeOption?/:notificationId?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: BcmDashboard,
  },
  ASSESSMENT_FORM: {
    name: 'Assessment',
    path: `/assessment-form/:formId/:formTitle/:progress`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: AssessmentForm,
    roles: [Role.speechcrafter],
  },
  DASHBOARD: {
    name: 'Dashboard',
    path: `/:activeSection?/:activeSubSection?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: Dashboard,
  },
};

export const SocialRoutes = {
  BADGE_SHARE: {
    name: 'badgeShare',
    path: `public/social/:slug?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: SharedBadge,
  },
};

export const ErrorRoutes = {
  ERROR_PAGE: {
    name: 'error',
    path: `:status?/:errorType?`,
    icon: <SpeedIcon />,
    isDisabled: true,
    component: Error,
    ispublic: false,
  },
};

export const AppRoutes = {
  ERROR: {
    path: `/error/*`,
    name: 'Error',
    component: errorLayout(
      RoutesHOC(ErrorRoutes, `/error`),
    ),
  },
  SOCIAL: {
    path: `/public/social/:slug?`,
    name: 'Social',
    component: publicLayout(
      RoutesHOC(SocialRoutes, `/public/social`),
    ),
  },
  DASHBOARD: {
    path: `/*`,
    name: 'Dashboard',
    component: dashboardLayout(
      RoutesHOC(
        DashboardRoutes,
        ``,
      ),
    ),
  },
};

export const USER_LANDING_PAGE = ``;

export const AppRouter = RoutesHOC(AppRoutes, USER_LANDING_PAGE);